import { useRef } from "react"

import Style from "./style"

import useGetSeedTicketTypeList from "entity/event/useGetSeedTicketTypeList"
import usePostSeedTicketTypeGive from "entity/account/usePostAccountSeedTicketGive"

import DefaultModal from "shared/ui/DefaultModal"
import DefaultButton from "shared/ui/DefaultButton"

const GiveModal = ({ accountSelect, closeEvent }) => {
    const seedTicketTypeIdxRef = useRef()
    const numberRef = useRef()

    const [seedTicketTypeList] = useGetSeedTicketTypeList()
    const [giveTicket] = usePostSeedTicketTypeGive(seedTicketTypeIdxRef, accountSelect, numberRef, closeEvent)

    // 시드권 선택 이벤트
    const changeSelectEvent = (e) => {
        seedTicketTypeIdxRef.current = e.target.value
    }

    return (
        <DefaultModal title="시드권 지급" closeEvent={closeEvent}>
            <Style.Wrapper>
                <select onChange={changeSelectEvent}>
                    <option>== 시드권 종류 ==</option>
                    {seedTicketTypeList?.data?.seed_ticket_type?.map(elem =>
                        <option value={elem?.idx}>{elem?.name}</option>
                    )}
                </select>
                <input placeholder="개수 입력" ref={numberRef} />
                <DefaultButton small fitWidth clickEvent={giveTicket}>지급</DefaultButton>
            </Style.Wrapper>
        </DefaultModal>
    )
}

export default GiveModal